import { hasPermission } from '@/hooks/useBackendMenu'
import { uploadFile } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Registro, registros } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormNovoRegistro from '../forms/NovoRegistro'
import { useUpdateDigitacaoQueryData } from '../pages/useDigitacaoData'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function NovoRegistroModal() {
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { dia } = useParams()
    const { mutateAsync, isLoading } = registros.mutations.useCreate()
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<Required<Registro>> = async ({
        fileUrl,
        ...data
    }) => {
        const filename = await uploadFile(fileUrl, baseUrl)
        await mutateAsync(
            { ...data, empresaId, origem: 2, fileUrl: filename, funcionarioId },
            {
                onSuccess: registro => {
                    setQueryData('REGISTRO', registro)
                    toast.success('Registro salvo com sucesso')
                },
                onError: ({ statusCode, message }) => {
                    if (statusCode >= 400 && statusCode < 500) {
                        toast.error(message)
                    } else {
                        toast.error('Erro ao salvar registro')
                    }
                },
            },
        )
    }

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={{ data: dia }}
            open={
                hasPermission(['create', 'Registros']) ||
                funcionarioPodeSolicitarAjustes()
            }
        >
            <Dialog.Title>Novo registro</Dialog.Title>
            <Dialog.Content>
                <FormNovoRegistro />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
